exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1nfu8fbKylC79qUOxX5W_j{color:#0078d4}.I05yy9iVNYwiu2BRWFfaq{color:#fa4}._3LHGrCCUCy2M0Pz56_Xxct{color:#498205}._16GjG2DEs0P5WgOlQBXGq6{color:#7a7574}.qY3lI0AiGxD6daPMABD1V{font-size:14px;color:\"[theme:neutralSecondary, default:#666666]\"}._1MOCP5CmBnCBUXi4BKFRJu{height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir=ltr] ._1MOCP5CmBnCBUXi4BKFRJu{margin-left:-10px;padding-right:20px}html[dir=rtl] ._1MOCP5CmBnCBUXi4BKFRJu{margin-right:-10px;padding-left:20px}.xA_C2-TNN13qaypwb6YxO{font-size:32px}", ""]);
// Exports
exports.locals = {
	"dot1": "_1nfu8fbKylC79qUOxX5W_j",
	"dot2": "I05yy9iVNYwiu2BRWFfaq",
	"dot3": "_3LHGrCCUCy2M0Pz56_Xxct",
	"dot4": "_16GjG2DEs0P5WgOlQBXGq6",
	"legendText": "qY3lI0AiGxD6daPMABD1V",
	"legendContainer": "_1MOCP5CmBnCBUXi4BKFRJu",
	"dotIcon": "xA_C2-TNN13qaypwb6YxO"
};